var _style, _rect, _defs, _rect2, _defs2, _rect3, _defs3, _rect4, _defs4, _rect5, _defs5, _rect6, _defs6, _rect7, _defs7, _rect8, _defs8, _rect9, _defs9, _rect10, _defs10, _rect11, _defs11, _rect12, _defs12, _rect13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleAuthenticator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 71.6 64.4",
    style: {
      enableBackground: "new 0 0 71.6 64.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:none;}\n\t.st1{clip-path:url(#SVGID_00000030487551360315577290000015607956037747834497_);fill:#A09F9F;}\n\t.st2{clip-path:url(#SVGID_00000002357485124529711790000010973624446015269505_);fill:#C2C1C0;}\n\t.st3{clip-path:url(#SVGID_00000150815782472373463620000011631286681900092038_);fill:#C2C1C0;}\n\t.st4{clip-path:url(#SVGID_00000046325080146585046200000004000277511402929839_);fill:#686868;}\n\t.st5{clip-path:url(#SVGID_00000057826228773992444030000002264511246731141544_);fill:#C3C3C3;}\n\t.st6{clip-path:url(#SVGID_00000047782241451504534740000017977226196913830074_);fill:#474748;}\n\t.st7{clip-path:url(#SVGID_00000061434943674088872890000002188259259625619111_);fill:#BFBFBF;}\n\t.st8{clip-path:url(#SVGID_00000127045149463443517940000004100878142709439630_);fill:#BFBFBF;}\n\t.st9{clip-path:url(#SVGID_00000049929476721865205560000013331394451196085412_);fill:#B0B0B1;}\n\t.st10{clip-path:url(#SVGID_00000086658785629190229800000003042098195299433627_);fill:#939393;}\n\t.st11{clip-path:url(#SVGID_00000085966490122376022320000001960155087669936288_);fill:#777677;}\n\t.st12{clip-path:url(#SVGID_00000041257040289059797050000006099173192654336653_);fill:#BEBEBE;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -414.3,
    y: -98.2,
    className: "st0",
    width: 1440,
    height: 979
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M35.5,53.1c-0.7,0.1-1.3,0.6-1.5,1.3c-0.2,0.7,0.1,1.6,0.7,2c0.5,0.3,1.1,0.4,1.6,0.3 c0.6-0.2,1-0.6,1.2-1.2c0.3-0.7,0-1.7-0.6-2.1C36.5,53.2,36,53.1,35.5,53.1z M19.5,46.6c-0.7,0.1-1.3,0.6-1.5,1.3 c-0.2,0.7,0,1.5,0.5,2c0.4,0.3,0.8,0.5,1.3,0.5c0.7,0,1.3-0.4,1.6-1c0.3-0.5,0.3-1.2,0-1.7C21.2,46.9,20.3,46.4,19.5,46.6  M13,30.6c-0.4,0.1-0.8,0.3-1,0.6c-0.6,0.6-0.7,1.5-0.3,2.2c0.4,0.8,1.5,1.2,2.3,0.9c0.9-0.3,1.4-1.4,1.1-2.3 C14.9,31.1,13.9,30.4,13,30.6 M19.8,14.7c-0.3,0-0.6,0.1-0.9,0.3c-0.7,0.4-1,1.3-0.8,2c0.2,0.8,1,1.5,1.8,1.4 c0.9,0,1.7-0.7,1.8-1.5c0.1-0.6-0.1-1.3-0.5-1.7C20.8,14.9,20.3,14.7,19.8,14.7 M35.5,8.1c-0.3,0.1-0.6,0.2-0.9,0.4 c-0.6,0.5-0.8,1.5-0.5,2.2c0.4,0.9,1.5,1.4,2.4,1c0.9-0.3,1.5-1.4,1.2-2.3C37.4,8.6,36.4,8,35.5,8.1 M32.6,5.2 c4.3-0.5,8.8,0,12.8,1.5c3.7,1.4,7.1,3.5,9.8,6.3c-2.4,2.3-4.7,4.7-7.1,7.1c-1.5-1.5-3.3-2.7-5.2-3.6c-2.6-1.2-5.5-1.7-8.3-1.5 c-3.2,0.2-6.3,1.3-8.9,3.2c-3.2,2.3-5.7,5.7-6.7,9.5c-0.8,2.8-0.9,5.8-0.2,8.6c0.5,2.3,1.5,4.5,2.9,6.4c1.3,1.8,2.9,3.3,4.8,4.5 c2.2,1.4,4.6,2.2,7.1,2.5c2.2,0.3,4.4,0.1,6.5-0.4c0.2-0.1,0.4,0.2,0.5,0.3c2.4,2.4,4.8,4.8,7.2,7.2c-4.3,2.1-9.1,3-13.9,2.7 c-4-0.3-7.9-1.4-11.4-3.4c-1.5-0.8-2.8-1.7-4.1-2.8c-1-0.9-2-1.8-2.9-2.8c-1.5-1.6-2.8-3.4-3.8-5.3c-0.2-0.5-0.5-0.9-0.7-1.4 c-0.3-0.5-0.5-1.1-0.7-1.6C10,41.6,9.6,40.9,9.4,40c0-0.1-0.1-0.2-0.1-0.3c-0.5-1.7-0.8-3.4-0.9-5.2c-0.2-2.2-0.1-4.4,0.3-6.6 c0.7-4.4,2.5-8.7,5.3-12.2c1.8-2.3,3.9-4.3,6.3-6C23.9,7.3,28.2,5.7,32.6,5.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000060021337087277461680000005764460795607143868_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 7.3,
    y: 4,
    style: {
      clipPath: "url(#SVGID_00000060021337087277461680000005764460795607143868_)",
      fill: "#A09F9F"
    },
    width: 48.9,
    height: 57
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -414.3,
    y: -98.2,
    className: "st0",
    width: 1440,
    height: 979
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000069366552556763993870000015043679023009436059_",
    d: "M35.5,8.1c0.9-0.2,1.9,0.4,2.1,1.3 c0.3,0.9-0.3,2-1.2,2.3c-0.9,0.4-2-0.1-2.4-1C33.7,10,34,9.1,34.6,8.6C34.8,8.4,35.1,8.2,35.5,8.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000180368811808933896120000000678423161618436527_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000069366552556763993870000015043679023009436059_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 32.7,
    y: 7,
    style: {
      clipPath: "url(#SVGID_00000180368811808933896120000000678423161618436527_)",
      fill: "#C2C1C0"
    },
    width: 6.2,
    height: 6.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -414.3,
    y: -98.2,
    className: "st0",
    width: 1440,
    height: 979
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000164500509679002106210000008336387338558383013_",
    d: "M13,30.6c0.9-0.2,1.9,0.4,2.1,1.3 c0.3,0.9-0.2,1.9-1.1,2.3c-0.8,0.4-1.9,0-2.3-0.9c-0.4-0.7-0.3-1.6,0.3-2.2C12.2,30.9,12.6,30.7,13,30.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000002346547172624821030000007688357945882851739_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000164500509679002106210000008336387338558383013_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.3,
    y: 29.4,
    style: {
      clipPath: "url(#SVGID_00000002346547172624821030000007688357945882851739_)",
      fill: "#C2C1C0"
    },
    width: 6.1,
    height: 6.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -414.3,
    y: -98.2,
    className: "st0",
    width: 1440,
    height: 979
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000006673780110104676510000001583244342397930648_",
    d: "M51.4,46.6c-0.7,0.1-1.4,0.7-1.5,1.5 c-0.1,0.5,0,1,0.3,1.4c0.3,0.5,1,0.9,1.6,0.8c0.5,0,1-0.2,1.3-0.6c0.3-0.3,0.5-0.7,0.5-1.2c0.1-0.7-0.3-1.4-0.9-1.7 C52.4,46.6,51.9,46.5,51.4,46.6z M34.6,23.8c-1.2,0.2-2.5,0.6-3.5,1.3c-1.4,0.8-2.4,2.1-3.2,3.5c-0.9,1.7-1.1,3.7-0.7,5.6 c0.2,1.2,0.7,2.3,1.4,3.3c0.5,0.7,1,1.3,1.6,1.8c3.4,3.4,6.7,6.7,10.1,10.1c2.9-0.8,5.5-2.3,7.7-4.4c2.6-2.5,4.4-5.9,5.1-9.6 c0-0.1,0-0.2,0.1-0.2c1.7,0,3.5,0,5.2,0c1.1,0,2.2-0.9,2.4-2c0-0.1,0-0.1,0-0.2c0.1-0.3,0.1-0.7,0.1-1l0,0 C60.7,31,59.6,30,58.4,30c-4.7,0-9.5,0-14.2,0c-0.4-1.3-1.1-2.5-2-3.5c-1.5-1.6-3.6-2.6-5.9-2.7C35.8,23.8,35.2,23.7,34.6,23.8  M55.2,13L55.2,13c1.5,1.5,2.8,3.1,3.9,4.8c2.1,3.3,3.5,7.2,4,11.1c0.3,2.6,0.3,5.3-0.1,7.9c-0.7,4.7-2.8,9.2-5.7,12.9 c-2.5,3.1-5.6,5.6-9.2,7.4l0,0C48,57,47.9,57,47.8,56.9c-2.4-2.4-4.8-4.8-7.2-7.2c-0.1-0.1-0.3-0.4-0.5-0.3 c-2.1,0.5-4.3,0.7-6.5,0.4c-2.5-0.3-5-1.2-7.1-2.5c-1.9-1.2-3.5-2.7-4.8-4.5c-1.4-1.9-2.4-4.1-2.9-6.4c-0.6-2.8-0.6-5.8,0.2-8.6 c1.1-3.8,3.5-7.2,6.7-9.5c2.6-1.9,5.7-3,8.9-3.2c2.8-0.2,5.7,0.3,8.3,1.5c2,0.9,3.7,2.1,5.2,3.6C50.5,17.8,52.9,15.4,55.2,13"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000144318027841462539140000001014590553378419865_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000006673780110104676510000001583244342397930648_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 17.1,
    y: 12,
    style: {
      clipPath: "url(#SVGID_00000144318027841462539140000001014590553378419865_)",
      fill: "#686868"
    },
    width: 47.2,
    height: 46.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -414.3,
    y: -98.2,
    className: "st0",
    width: 1440,
    height: 979
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000152258574166787083920000015074441081575879808_",
    d: "M19.8,14.7c0.5,0,1,0.2,1.4,0.5c0.4,0.4,0.7,1.1,0.5,1.7 c-0.1,0.9-1,1.6-1.8,1.5c-0.8,0-1.7-0.6-1.8-1.4c-0.2-0.8,0.2-1.6,0.8-2C19.1,14.8,19.4,14.7,19.8,14.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000177479193379330437730000009320656501810316979_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152258574166787083920000015074441081575879808_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.8,
    y: 13.7,
    style: {
      clipPath: "url(#SVGID_00000177479193379330437730000009320656501810316979_)",
      fill: "#C3C3C3"
    },
    width: 6,
    height: 5.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -414.3,
    y: -98.2,
    className: "st0",
    width: 1440,
    height: 979
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000171689849226863629370000005884962737581798064_",
    d: "M34.6,23.8c0.6-0.1,1.1-0.1,1.7-0.1 c2.2,0.1,4.3,1.1,5.9,2.7c0.9,1,1.6,2.2,2,3.5c-2.8,0-5.6,0-8.4,0c-0.7,0-1.4,0.3-1.9,0.9c-0.4,0.4-0.6,0.9-0.6,1.4 c-0.1,0.8,0.3,1.7,1,2.2c0.4,0.3,1,0.5,1.6,0.5c7.4,0,14.9,0,22.3,0c0.3,0,0.6,0,0.8-0.1c0.8-0.2,1.5-0.9,1.7-1.7 c0,0.1,0.1,0.1,0,0.2c-0.2,1.1-1.3,1.9-2.4,2c-1.7,0-3.5,0-5.2,0c-0.1,0-0.1,0.1-0.1,0.2c-0.6,3.6-2.4,7-5.1,9.6 c-2.1,2.1-4.8,3.6-7.7,4.4c-3.4-3.4-6.7-6.7-10.1-10.1c-0.6-0.6-1.2-1.2-1.6-1.8c-0.7-1-1.2-2.1-1.4-3.3c-0.4-1.9-0.1-3.9,0.7-5.6 c0.7-1.4,1.8-2.7,3.2-3.5C32.2,24.4,33.4,24,34.6,23.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165949024897366624490000004282181102957389215_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000171689849226863629370000005884962737581798064_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 25.9,
    y: 22.7,
    style: {
      clipPath: "url(#SVGID_00000165949024897366624490000004282181102957389215_)",
      fill: "#474748"
    },
    width: 35.9,
    height: 27.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: -414.3,
    y: -98.2,
    className: "st0",
    width: 1440,
    height: 979
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000054982746153627605670000003432000852447320716_",
    d: "M33.9,30.8c0.5-0.5,1.2-0.9,1.9-0.9c2.8,0,5.6,0,8.4,0 c4.7,0,9.5,0,14.2,0c1.2,0,2.3,1,2.4,2.2c0,0,0,0.1,0,0.1c-0.2-1.1-1.3-1.9-2.4-1.9c-7.3,0-14.6,0-22,0c-0.5,0-0.9,0-1.4,0.1 c-0.5,0.2-1,0.5-1.3,1c-0.2,0.3-0.3,0.6-0.4,0.9C33.3,31.8,33.6,31.2,33.9,30.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062152133822308248040000017982588167598387134_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054982746153627605670000003432000852447320716_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 32.3,
    y: 29,
    style: {
      clipPath: "url(#SVGID_00000062152133822308248040000017982588167598387134_)",
      fill: "#BFBFBF"
    },
    width: 29.5,
    height: 4.3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: -414.3,
    y: -98.2,
    className: "st0",
    width: 1440,
    height: 979
  })), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000144319226470621258840000013628841334257960876_",
    d: "M19.5,46.6c0.8-0.2,1.7,0.3,2,1c0.3,0.5,0.2,1.2,0,1.7 c-0.3,0.6-0.9,1-1.6,1c-0.5,0-1-0.2-1.3-0.5c-0.5-0.5-0.7-1.3-0.5-2C18.3,47.2,18.9,46.7,19.5,46.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041994335263182546460000010319736944205885360_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000144319226470621258840000013628841334257960876_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.8,
    y: 45.4,
    style: {
      clipPath: "url(#SVGID_00000041994335263182546460000010319736944205885360_)",
      fill: "#BFBFBF"
    },
    width: 6,
    height: 5.9
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: -414.3,
    y: -98.2,
    className: "st0",
    width: 1440,
    height: 979
  })), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000132077792395846866740000002821476694810854017_",
    d: "M35,30.4c0.4-0.2,0.9-0.1,1.4-0.1c7.3,0,14.6,0,22,0 c1.1,0,2.2,0.9,2.4,1.9c0,0,0-0.1,0-0.1l0,0c0,0.3,0,0.7-0.1,1c-0.2,0.8-0.9,1.5-1.7,1.7C58.7,35,58.4,35,58.1,35 c-7.4,0-14.9,0-22.3,0c-0.6,0-1.1-0.2-1.6-0.5c-0.7-0.5-1-1.4-1-2.2c0.2-0.3,0.2-0.6,0.4-0.9C34.1,31,34.5,30.6,35,30.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142142628717878275260000012712806771801896860_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132077792395846866740000002821476694810854017_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 32.2,
    y: 29.3,
    style: {
      clipPath: "url(#SVGID_00000142142628717878275260000012712806771801896860_)",
      fill: "#B0B0B1"
    },
    width: 29.6,
    height: 6.7
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: -414.3,
    y: -98.2,
    className: "st0",
    width: 1440,
    height: 979
  })), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000135658608018084317830000011690042678975434929_",
    d: "M9.3,39.8c0.1,0.1,0.1,0.2,0.1,0.3 c0.2,0.8,0.5,1.6,0.8,2.4c0.2,0.5,0.5,1.1,0.7,1.6c0.2,0.5,0.5,0.9,0.7,1.4c1.1,1.9,2.3,3.7,3.8,5.3c0.9,1,1.9,1.9,2.9,2.8 c1.3,1,2.7,2,4.1,2.8c3.5,1.9,7.4,3.1,11.4,3.4c4.8,0.3,9.6-0.6,13.9-2.7C47.9,57,48,57,48,57.1l0,0c-2.5,1.2-5.2,2.1-7.9,2.5 c-3.3,0.5-6.8,0.4-10.1-0.3c-4-0.8-7.8-2.6-11-5.1c-3.7-2.8-6.7-6.7-8.5-11C10,42.2,9.6,41,9.3,39.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008133569336398100140000014668764270557680002_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000135658608018084317830000011690042678975434929_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 8.3,
    y: 38.8,
    style: {
      clipPath: "url(#SVGID_00000008133569336398100140000014668764270557680002_)",
      fill: "#939393"
    },
    width: 40.7,
    height: 22.2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: -414.3,
    y: -98.2,
    className: "st0",
    width: 1440,
    height: 979
  })), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000032615380128372832380000005897504274031884713_",
    d: "M51.4,46.6c0.5-0.1,0.9,0,1.3,0.3c0.6,0.3,0.9,1,0.9,1.7 c0,0.4-0.2,0.9-0.5,1.2c-0.3,0.3-0.8,0.6-1.3,0.6c-0.6,0-1.3-0.3-1.6-0.8c-0.3-0.4-0.4-0.9-0.3-1.4C50,47.3,50.7,46.7,51.4,46.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047766848132977106100000010618386823077156259_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000032615380128372832380000005897504274031884713_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 48.8,
    y: 45.5,
    style: {
      clipPath: "url(#SVGID_00000047766848132977106100000010618386823077156259_)",
      fill: "#777677"
    },
    width: 5.8,
    height: 5.8
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: -414.3,
    y: -98.2,
    className: "st0",
    width: 1440,
    height: 979
  })), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000001636821720684874200000015233854209636046482_",
    d: "M35.5,53.1c0.5-0.1,1.1,0,1.5,0.4 c0.6,0.5,0.9,1.4,0.6,2.1c-0.2,0.6-0.7,1-1.2,1.2c-0.5,0.2-1.2,0.1-1.6-0.3c-0.6-0.4-0.9-1.3-0.7-2C34.2,53.8,34.8,53.3,35.5,53.1 z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000155825014307278654130000007300091458138830012_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000001636821720684874200000015233854209636046482_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 32.8,
    y: 52.1,
    style: {
      clipPath: "url(#SVGID_00000155825014307278654130000007300091458138830012_)",
      fill: "#BEBEBE"
    },
    width: 6.1,
    height: 5.9
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: -414.3,
    y: -98.2,
    className: "st0",
    width: 1440,
    height: 979
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAuthenticator);
export default __webpack_public_path__ + "static/media/google-authenticator.f4ade6cea0b41b50fadc3be55c1e631d.svg";
export { ForwardRef as ReactComponent };